import { Pipe, PipeTransform } from '@angular/core';
import { isArray } from 'ngx-bootstrap/chronos';

@Pipe({
  name: 'reverseList',
  standalone: false,
})
export class ReverseListPipe implements PipeTransform {
  public transform(value: unknown[], doTransform = true): unknown[] {
    // When doTransform = false nothing will happen to the list.
    if (!isArray(value)) {
      console.error('Tried to reverse an array that was not an array. Doing nothing', value);
      return value;
    }
    if (doTransform) {
      return [...value].reverse();
    }
    return value;
  }
}
